__turbopack_context__.v({
  "spin": "styles-module-scss-module__7mfGdq__spin",
  "spinner": "styles-module-scss-module__7mfGdq__spinner",
  "toastContainer": "styles-module-scss-module__7mfGdq__toastContainer",
  "toastContent": "styles-module-scss-module__7mfGdq__toastContent",
});
